module.exports = __webpack_public_path__ + "static/media/crow_eat_roti.3dea2b87.png";